export const homeObjectOne = {
  id: "events",
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "Events",
  headline: "Check out all the events",
  description: "See a list of all the events that are happening now!",
  buttonLabel: "Events List",
  imgStart: true,
  img: "images/basketball.svg",
  alt: "basketball image",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjectTwo = {
  id: "signup",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "Sign Up",
  headline: "Get moving today!",
  description: "Easy, just use your google account",
  buttonLabel: "Sign Up",
  imgStart: false,
  img: "images/tennis.svg",
  alt: "tennis image",
  dark: true,
  primary: true,
  darkText: false,
};
